export class PartnerModel {
    public imgName: string
    public link: string

    constructor(imgName: string, link: string) {
        this.imgName = imgName;
        this.link = link;
    }
}
